import { authStore } from "@/routes/login/auth-store"
import { LogOut } from "lucide-react"
import { useNavigate } from "react-router-dom"
import Flex from "../../../components/flex"

const UserInfo = ({ userName, userId }) => {
  const { apiLogout } = authStore()
  const navigate = useNavigate()

  const LogoutAction = async () => {
    const success = await apiLogout()
    if (success) navigate("/", { replace: true })
  }

  return (
    <footer className="pt-3 mt-2 border-t border-white/10">
      <Flex className="items-center justify-between">
        <div className="min-w-0">
          <p className="text-[11px] tracking-wide text-white/50 font-medium">{userId}</p>

          <span className="font-semibold text-sm truncate">{userName}</span>
        </div>

        <button
          className="w-9 h-9 shrink-0 rounded-xl text-white/70
            flex items-center justify-center
            hover:bg-white/10 hover:text-white
            transition-colors cursor-pointer
          "
          onClick={LogoutAction}
        >
          <LogOut size={18} />
        </button>
      </Flex>
    </footer>
  )
}

export default UserInfo
